import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { dashboardApiConfig } from 'src/config';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Grid,
  Box,
  Button,
  makeStyles,
  Card,
  CardActions,
  CardContent,
  CardHeader, 
  Divider,
  TextField,
  Typography,
  FormControl,
  MenuItem, 
  Select, 
  InputLabel,
  hexToRgb,
  Paper 
} from '@material-ui/core';
import wait from 'src/utils/wait';
import { withStyles, styled  } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import track from 'src/utils/analytics';
import { Link as RouterLink } from 'react-router-dom';



const StyledTextField = styled(TextField, {
  name: "StyledTextField",
})({
  width: '200%',
  '@media (max-width: 600px)': {
    width: '100%', 
  },
});


const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);


const AccordionSummary = withStyles({
  root: {
    backgroundColor: '#474343',
    color: '#ffffff',
    
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {color: '#ffffff',},
})(MuiAccordionSummary);


const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);


const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    padding: '2px 2px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    height: 65
  },
  divider: {
    height: 30,
    margin: 5
  },
  cardHeader: {
    color: hexToRgb('#787878')
  },
}));


const WIFIQRCode = ({ className, text, format, qrcodeName, ...rest }) => {
  const classes = useStyles();
  const [img, setImg] = useState();
  const [expanded, setExpanded] = React.useState('expand_wifi');

  const wifi_accordioan = (wifiaccordioan) => (event, newExpanded) => {
    setExpanded(newExpanded ? wifiaccordioan : false);
  };


  const [selectedEncryption, setSelectedEncryption] = useState('');
  const wifioption = [
    { name: 'No Encryption' },
    { name: 'WEP' },
    { name: 'WPA/WPA2' },
  ];
  const encryptionhandleChange = (event) => {
    setSelectedEncryption(event.target.value);
  };

  const [light, setLight] = useState('#ffffff');
  const [dark, setDark] = useState('#050505');
 
  

  const images = [
    "https://www.apitier.com/static/logo/facebook.png",

    "https://www.apitier.com/static/logo/youtube.png",

    "https://www.apitier.com/static/logo/instagram.png",

    "https://www.apitier.com/static/logo/wechat.png",

    "https://www.apitier.com/static/logo/tiktok.png",

    "https://www.apitier.com/static/logo/facebook-messenger.png",

    "https://www.apitier.com/static/logo/whatsapp.png",

    "https://www.apitier.com/static/logo/snapchat.png",

    "https://www.apitier.com/static/logo/telegram.png",

    "https://www.apitier.com/static/logo/pinterest.png",

    "https://www.apitier.com/static/logo/twitter.png",

    "https://www.apitier.com/static/logo/reddit.png",

    "https://www.apitier.com/static/logo/linkedin.png",

    "https://www.apitier.com/static/logo/quora.png",

    "https://www.apitier.com/static/logo/gmail.png",

    "https://www.apitier.com/static/logo/phone.png",

    "https://www.apitier.com/static/logo/wifi.png",

    "https://www.apitier.com/static/logo/shopify.png",

    "https://www.apitier.com/static/logo/googleplay.png",

    "https://www.apitier.com/static/logo/google-plus.png",

    "https://www.apitier.com/static/logo/spotify.png",

    "https://www.apitier.com/static/logo/share.png",

    "https://www.apitier.com/static/logo/bitcoin.png",

    "https://www.apitier.com/static/logo/sms.png",

    "https://www.apitier.com/static/logo/link.png",

    "https://www.apitier.com/static/logo/phonecall.png",

    "https://www.apitier.com/static/logo/location.png",

    "https://www.apitier.com/static/logo/skype.png",

    "https://www.apitier.com/static/logo/event.png",

    "https://www.apitier.com/static/logo/paypal.png",

    "https://www.apitier.com/static/logo/text.png",

    "https://www.apitier.com/static/logo/zoom.png",  

    "https://www.apitier.com/static/logo.png", 
  ];

  const [selectedImage, setSelectedImage] = useState();

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleClearImage = () => {
    setSelectedImage(null);
  }

  const handleUploadImage = () => {
    const confirmed = window.confirm("Please Sign Up for the API for the advance features!!");
    if (confirmed) {
      window.open('https://www.apitier.com/signup', '_blank');
    }
  };

  useEffect(() => {
    generateqrCode(text, light, dark, selectedImage)
  }, []);
  const handleDownloadQRCodeEvent = () => {
    track.event('download_qrcode_apitier');
  }
  const handleGenerateQRCodeEvent = () => {
    track.event('generate_qrcode_apitier');
  }
  const redirectAIQRCodeEvent = () => {
    track.event('redirect_aiqrcodes_from_apitier');
  }

  const downloadqrCode = async () => {
    try {
      handleDownloadQRCodeEvent();

      const link = document.createElement('a')
      link.href = img;
      link.download = 'wifi_qrcode.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

    } catch (err) {
      console.error(err);
    }
  };

  const generateqrCode = async (text, light, dark, selectedImage) => {

    try {
      handleGenerateQRCodeEvent();

      const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
          "text": text,
          "width": 150,
          "height": 150,
          "options": {
            "colorLight": light,
            "colorDark": dark,
            "logo": selectedImage,
            "logoBackgroundColor": "#ffffff",
          }
        })
      }

      const res = await fetch(dashboardApiConfig.dashboard_barcode_api_url + '/generate/qrcode?x-api-key=' + dashboardApiConfig.dashboard_barcode_api_demo_key, requestOptions);
      const imageBlob = await res.blob();
      const imageObjectURL = URL.createObjectURL(imageBlob);
      setImg(imageObjectURL);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      spacing={3}
      {...rest}
    >
      <Grid
        item
        lg={8}
        md={6}
        xl={9}
        xs={12}
      >

        <Formik
          enableReinitialize
          initialValues={{
            name: '',
            password:'',
            encryption:'',
            colorlight: light,
            colordark: dark,
            customlogo: selectedImage,
            submit: null
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string(),
            password: Yup.string(),
            encryption: Yup.string(),
            colorlight: Yup.string().max(255),
            colordark: Yup.string().max(255),
            customlogo: Yup.string().max(255),
          })}
          onSubmit={async (values, {
            resetForm,
            setErrors,
            setStatus,
            setSubmitting
          }) => {
            try {
              // NOTE: Make API request
              generateqrCode(`WIFI:S:${values.name};T:${selectedEncryption};P:${values.password};;`, light, dark, selectedImage)

              await wait(200);
              resetForm();
              setStatus({ success: true });
              setSubmitting(false);
            } catch (err) {
              console.error(err);
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Card
                className={clsx(classes.root, className)}
                {...rest}
              >
                
                <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        textAlign="center"
                      >
                  <Typography
                    variant="h2"
                    align="left"
                    color="textPrimary"
                  >
                   
                   <br /> Create QRCode For Any {qrcodeName} Free
                  </Typography>
                  </Box>
                <CardHeader  >



                </CardHeader>
                <Divider />

        <Accordion expanded={expanded === 'expand_wifi'} onChange={wifi_accordioan('expand_wifi')}>
        <AccordionSummary expandIcon={<ExpandMore />} aria-controls="expand_wifi_content" id="expand_wifi_header">
        <Typography>ENTER WIFI</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <CardContent>
        <Grid
        container
        >
        <Grid
         item
         md={20}
         xs={12}
        >
        
        <StyledTextField 
        error={Boolean(touched.name && errors.name)}
        helperText={touched.name && errors.name}                          
        label=" Wireless SSID "                          
        name="name"                         
        onBlur={handleBlur}                          
        onChange={handleChange}                          
        value={values.name}                          
        variant="outlined"                          
        />                       
        </Grid>                      
        </Grid>                    
       
      <br /> <br />

        
        <Grid
        container
        >
        <Grid
         item
         md={20}
         xs={12}
        >
        
        <StyledTextField 
        error={Boolean(touched.password && errors.password)}
        helperText={touched.password && errors.password}                          
        label=" Password "                          
        name="password"                         
        onBlur={handleBlur}                          
        onChange={handleChange}                          
        value={values.password}                          
        variant="outlined"                          
        />                       
        </Grid>                      
        </Grid>                    
           
        <br /> <br />
        
       
        <Grid
        container
        >
        <Grid
         item
         md={20}
         xs={12}
        >
        <FormControl fullWidth>
        <InputLabel id="wifi-label">Encryption</InputLabel>
        <Select
         labelId="wifi-label"
         id="wifi"
         value={selectedEncryption}
         label="wifi"
         onChange={encryptionhandleChange}
        >
         {wifioption.map((wifi) => (
         <MenuItem key={wifi.name} value={wifi.name}>
         {`${wifi.name}`}
         </MenuItem>
         ))}
          </Select>
       </FormControl>
               
        </Grid>                      
        </Grid>                    
                        
        </CardContent>               
        </AccordionDetails>                        
        </Accordion>

        <br />

        <Accordion >
              <AccordionSummary expandIcon={<ExpandMore />} aria-controls="expand_url_content" id="expand_url_header">
                  <Typography>CHOOSE COLORS</Typography>
              </AccordionSummary>
                <AccordionDetails>
                    <CardContent>

          <Typography><b>COLORLIGHT</b></Typography>
          <Paper className={classes.paper}>
          <input   
            variant="contained"  
            style={{ margin: "0px 17px" }}
            type="color"
            value={light}
            onChange={e => setLight(e.target.value)} 
          />

          <Divider className={classes.divider} orientation="vertical" />

          <TextField
              label="COLORLIGHT"
              margin="normal"
              type="name"
              variant="outlined"
              style={{ margin: "0px 5px" }}
              size="small"
              placeholder="#ffffff"
              value={light} 
            />

          </Paper>
          <br /><br />
          <Typography><b>COLORLDARK</b></Typography>
          <Paper className={classes.paper}>
          <input   
            variant="contained"  
            style={{ margin: "0px 17px" }}
            type="color"
            value={dark}
            onChange={e => setDark(e.target.value)} 
          />

          <Divider className={classes.divider} orientation="vertical" />

          <TextField
              label="COLORLDARK"
              margin="normal"
              type="text"
              variant="outlined"
              style={{ margin: "0px 5px" }}
              size="small"
              placeholder="#050505"
              value={dark} 
            />

          </Paper>
                  </CardContent>
              </AccordionDetails>
        </Accordion>

        <br />


        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="expand_url_content" id="expand_url_header">
              <Typography>SET CUSTOM LOGO</Typography>
          </AccordionSummary>
            <AccordionDetails>
              <CardContent>

              {selectedImage && (
                      <div style={{ border: '1px solid grey', padding: '10px', width: '110px', height: '110px' }}>
                        <img src={selectedImage} alt="" style={{ maxWidth: '105%' }} />
                        
                        <Box sx={{ position: 'absolute', top: 100, left: 190 }}>
                          <Button 
                          variant="contained" 
                          color="secondary"  
                          onClick={handleUploadImage}>
                            Upload Image
                          </Button>
                        </Box>

                        <Box sx={{ position: 'absolute', top: 150, left: 190 }}>
                          <Button 
                          variant="contained" 
                          color="secondary" 
                          onClick={handleClearImage} >
                            Remove Image
                          </Button>
                        </Box>
                        </div>
                      )}

                      <br />
                      
                      <Grid container spacing={2}>
                        {images.map((imageUrl) => (
                          <Grid item xs={6} sm={1} key={imageUrl}>
                            <img
                              src={imageUrl}
                              alt=""
                              style={{ width: '100%', cursor: 'pointer' }}
                              onClick={() => handleImageClick(imageUrl)}
                            />
                          </Grid>
                        ))}
                      </Grid>
                      
              </CardContent>
        </AccordionDetails>
        </Accordion>
           

        <br />
        <Divider />

          <Box
                  p={2}
                  display="flex"
                  justifyContent="flex-end"
                >
                  <Button
                    color="secondary"
                    disabled={isSubmitting}
                    type="submit"
                    variant="contained"
                  >
                    Generate QRCode
                  </Button>
                </Box>
     
              </Card>
            </form>
          )}
        </Formik>

      </Grid>
      <Grid
        item
        lg={4}
        md={6}
        xl={3}
        xs={12}
      >
        <Card
          className={clsx(classes.root, className)}
          {...rest}
        >
          <CardContent>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="column"
              textAlign="center"
            >

              <img src={img} />
            </Box>
          </CardContent>
          <CardActions>

            <Button
              fullWidth
              alignItems="center"
              variant="contained"
              color="secondary"
              onClick={downloadqrCode}
            >
              Download QRCode
            </Button>
          </CardActions>
          <Divider />
            <Box
              p={2}
              display="flex"
              justifyContent="flex-end"
              >
            <Button
                      fullWidth 
                      alignItems="center"
                      variant="contained"
                      color="secondary"
                      component={RouterLink}
                      to={{ pathname: "https://ai.qrcodes.apitier.com/register" }}
                      target="_blank"
                      onClick={redirectAIQRCodeEvent}
                    >
                      Get Artistic QR Code
              </Button>
                  
            </Box>
        </Card>
      </Grid>
    </Grid>
  );
}




WIFIQRCode.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  format: PropTypes.string,
  qrcodeName: PropTypes.string

};

export default WIFIQRCode;

